export const colorConstants = {
  GET_SINGLE_REQUEST: "COLOR_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "COLOR_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "COLOR_GET_SINGLE_FAILURE",

  GET_ALL_REQUEST: "COLOR_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "COLOR_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "COLOR_GET_ALL_FAILURE",

  ADD_REQUEST: "COLOR_ADD_REQUEST",
  ADD_SUCCESS: "COLOR_ADD_SUCCESS",
  ADD_FAILURE: "COLOR_ADD_FAILURE",

  UPDATE_REQUEST: "COLOR_UPDATE_REQUEST",
  UPDATE_SUCCESS: "COLOR_UPDATE_SUCCESS",
  UPDATE_FAILURE: "COLOR_UPDATE_FAILURE",

  DELETE_REQUEST: "COLOR_DELETE_REQUEST",
  DELETE_SUCCESS: "COLOR_DELETE_SUCCESS",
  DELETE_FAILURE: "COLOR_DELETE_FAILURE",

  CLEAR: "COLOR_CLEAR",
};
